export function timeAgo(date: string | Date) {
  if (!date) return '';

  const convertedDate = typeof date === 'string' ? new Date(date) : date;

  const userLocale = Intl.DateTimeFormat().resolvedOptions().locale;
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  convertedDate.toLocaleString(userLocale, { timeZone: userTimezone });

  const now = Date.now();
  const diffInMilliseconds = now - convertedDate.getTime();

  if (diffInMilliseconds < 0) {
    return 'En el futuro';
  }

  const seconds = Math.floor(diffInMilliseconds / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const months = Math.floor(days / 30.44);
  const years = Math.floor(months / 12);

  let text = '';
  if (years > 0) {
    text = `hace ${years} año${years === 1 ? '' : 's'}`;
  } else if (months > 0) {
    text = `hace ${months} mes${months === 1 ? '' : 'es'}`;
  } else if (days > 0) {
    text = `hace ${days} día${days === 1 ? '' : 's'}`;
  } else if (hours > 0) {
    text = `hace ${hours} hora${hours === 1 ? '' : 's'}`;
  } else if (minutes > 0) {
    text = `hace ${minutes} minuto${minutes === 1 ? '' : 's'}`;
  } else {
    text = `hace ${seconds} segundo${seconds === 1 ? '' : 's'}`;
  }

  return text;
}
